<template>
    <div class="v-flex icon-gap">
        <v-tooltip bottom v-if="context.deviceLGSmart">
            <template v-slot:activator="{ on: tooltip }">
                <div
                    class="v-flex"
                    v-on   = "{ ...tooltip }"
                >
                    <c-data-hub-menu
                        :unit    = "context"
                    />

                </div>

            </template>
            <span>Letzte Bewegungen</span>
        </v-tooltip>

        <v-tooltip bottom v-if="context.deviceLGSmart">
            <template v-slot:activator="{ on: tooltip }">
                <a
                    :href   = "dashboardUrl"
                    target  = "_blank"
                    rel     = "noopener"
                    v-on    = "{ ...tooltip }"
                >
                    <v-icon color="white" size="23">mdi-monitor-dashboard</v-icon>
                </a>
            </template>
            <span>Liftguardian Smart</span>
        </v-tooltip>

        <p-liftguardian-status
            v-if     = "showLgsState && status"
            :status = "status"
        />
    </div>
</template>

<script>

import main                from "@/main";
import CDataHubMenu        from "@/modules/datahub/components/private/CDataHubMenu.vue";
import PLiftguardianStatus from "@/modules/datahub/components/private/PLiftguardianStatus.vue";
import Datahub             from "@/modules/datahub/service/Datahub";

const timerInterval = 5 * 60 * 1000;

export default {
    name: "CSiteLiftguardian",
    components: {
        PLiftguardianStatus,
        CDataHubMenu
    },

    props: {
        context: {
            required: true,
            type    : Object,
            default : function () {
                return null;
            }
        },
    },

    data: () => ({
        lgstimer: null,
        status: null,
    }),

    computed: {
        preferences () {
            return this.$store.getters.preferences;
        },

        showLgsState () {
            if (!this.preferences) {
                return null;
            }

            return this.preferences['lgsstate'];
        },

        dashboardUrl () {
            return main.url.dashboard().replace(/\/$/, "") + "/site/" + this.context.id;
        }
    },

    mounted() {
        this.setLgsTimer();
        this.getLgsStatus();
    },

    watch: {
        showLgsState () {
            this.setLgsTimer();
            this.getLgsStatus();
        },

        context () {
            this.setLgsTimer();
            this.getLgsStatus();
        }
    },

    methods: {
        setLgsTimer () {
            if (!this.context || !this.context.deviceLGSmart) {
                if (this.lgstimer) {
                    window.clearInterval(this.lgstimer);
                }

                return;
            }

            if (this.showLgsState) {
                if (!this.lgstimer) {
                    this.lgstimer = window.setInterval(this.getLgsStatus, timerInterval);
                }
            } else {
                if (this.lgstimer) {
                    window.clearInterval(this.lgstimer);
                }
            }
        },

        getLgsStatus () {
            if (!this.context || !this.showLgsState || !this.context.deviceLGSmart) {
                window.clearInterval(this.lgstimer);
                return;
            }

            Datahub.status(this.context.id).then ((data) => {
                this.status = data;
            })
        }
    }
}
</script>

<style scoped>
    .icon-gap {
        gap: 5px;
    }
</style>
